/* nh-b2b: carousels (highlights, testimonials) + product page interactions */
(function () {
  /* ---------- Carousels ---------- */
  function stepOf(track, cardSel) {
    var card = track.querySelector(cardSel);
    if (!card) return track.clientWidth;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 20;
    return card.getBoundingClientRect().width + gap;
  }

  function wire(root, cardSel, prevSel, nextSel) {
    if (root.dataset.nhCarouselReady === 'true') return;
    var track = root.querySelector('[data-nh-track], [data-nh-rev-track]');
    var prev = root.querySelector(prevSel);
    var next = root.querySelector(nextSel);
    if (!track || !prev || !next) return;
    root.dataset.nhCarouselReady = 'true';

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= max;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.style.opacity = atStart ? '0.35' : '';
      next.style.opacity = atEnd ? '0.35' : '';
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepOf(track, cardSel), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: stepOf(track, cardSel), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function bootCarousels() {
    document.querySelectorAll('[data-nh-carousel]').forEach(function (el) {
      wire(el, '.nh-hl__card', '[data-nh-prev]', '[data-nh-next]');
    });
    document.querySelectorAll('[data-nh-rev]').forEach(function (el) {
      wire(el, '.nh-rev__card', '[data-nh-rev-prev]', '[data-nh-rev-next]');
    });
  }

  /* ---------- Product page ---------- */
  function initPdp(root) {
    if (root.dataset.nhPdpReady === 'true') return;
    root.dataset.nhPdpReady = 'true';

    /* Gallery: thumbnails swap the main image */
    var mainImg = root.querySelector('[data-nh-main-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nh-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (mainImg && full) mainImg.src = full;
        thumbs.forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var thumbTrack = root.querySelector('[data-nh-thumbs]');
    var tPrev = root.querySelector('[data-nh-thumb-prev]');
    var tNext = root.querySelector('[data-nh-thumb-next]');
    if (thumbTrack && tPrev && tNext) {
      function tUpdate() {
        var max = thumbTrack.scrollWidth - thumbTrack.clientWidth - 1;
        tPrev.disabled = thumbTrack.scrollLeft <= 0;
        tNext.disabled = thumbTrack.scrollLeft >= max;
      }
      tPrev.addEventListener('click', function () {
        thumbTrack.scrollBy({ left: -thumbTrack.clientWidth * 0.8, behavior: 'smooth' });
      });
      tNext.addEventListener('click', function () {
        thumbTrack.scrollBy({ left: thumbTrack.clientWidth * 0.8, behavior: 'smooth' });
      });
      thumbTrack.addEventListener('scroll', tUpdate, { passive: true });
      window.addEventListener('resize', tUpdate);
      tUpdate();
    }

    /* Variant data */
    var dataEl = root.querySelector('[data-nh-variants]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }
    var selected = {};
    root.querySelectorAll('[data-nh-val]').forEach(function (b) {
      if (b.classList.contains('is-active')) selected[b.getAttribute('data-option')] = b.getAttribute('data-value');
    });

    var variantIdInput = root.querySelector('[data-nh-variant-id]');
    var priceNow = root.querySelector('.nh-pdp__price-now');
    var priceOld = root.querySelector('.nh-pdp__price-old');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function applyVariant() {
      var keys = Object.keys(selected);
      if (!keys.length) return;
      var match = variants.find(function (v) {
        return keys.every(function (k, i) { return v['option' + (i + 1)] === selected[k]; });
      });
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price);
      if (priceOld) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceOld.textContent = money(match.compare_at_price);
          priceOld.style.display = '';
        } else {
          priceOld.style.display = 'none';
        }
      }
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src;
        var url = match.featured_image.src.split('?')[0];
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full').split('?')[0] === url);
        });
      }
    }

    root.querySelectorAll('[data-nh-opt]').forEach(function (optEl) {
      var oname = optEl.getAttribute('data-nh-opt');
      var current = optEl.querySelector('[data-nh-opt-current]');
      optEl.querySelectorAll('[data-nh-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          optEl.querySelectorAll('[data-nh-val]').forEach(function (o) { o.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[oname] = btn.getAttribute('data-value');
          if (current) current.textContent = btn.getAttribute('data-value');
          applyVariant();
        });
      });
      var viewAll = optEl.querySelector('[data-nh-viewall]');
      if (viewAll) {
        viewAll.addEventListener('click', function () {
          var expanded = optEl.classList.toggle('is-expanded');
          viewAll.textContent = expanded ? 'Show less' : viewAll.textContent.replace('Show less', 'View all');
        });
      }
    });

    /* Quantity stepper */
    var qty = root.querySelector('[data-nh-qty]');
    var qtyInput = root.querySelector('[data-nh-qty-input]');
    var minus = root.querySelector('[data-nh-qty-minus]');
    var plus = root.querySelector('[data-nh-qty-plus]');
    function setQty(n) {
      n = Math.max(1, n);
      if (qty) qty.value = n;
      if (qtyInput) qtyInput.value = n;
    }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) + 1); });
  }

  /* ---------- Footer quote form: WhatsApp hand-off ---------- */
  function initFooterQuote() {
    var wa = document.querySelector('[data-nh-wa]');
    if (!wa || wa.dataset.nhWaReady === 'true') return;
    wa.dataset.nhWaReady = 'true';

    wa.addEventListener('click', function (e) {
      var form = wa.closest('form');
      if (!form) return;
      var val = function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el && el.value ? el.value.trim() : '';
      };
      var name = val('contact[name]');
      var email = val('contact[email]');
      var need = val('contact[body]');

      if (!name && !email && !need) return; // nothing typed: open the empty chat

      var lines = ['Hi, I would like to get a quote.'];
      if (name) lines.push('Name: ' + name);
      if (email) lines.push('Email: ' + email);
      if (need) lines.push('Requirement: ' + need);

      e.preventDefault();
      var base = wa.getAttribute('href').split('?')[0];
      window.open(base + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
    });
  }

  function boot() {
    bootCarousels();
    document.querySelectorAll('[data-nh-pdp]').forEach(initPdp);
    initFooterQuote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nh-carousel]').forEach(function (el) {
      wire(el, '.nh-hl__card', '[data-nh-prev]', '[data-nh-next]');
    });
    e.target.querySelectorAll('[data-nh-rev]').forEach(function (el) {
      wire(el, '.nh-rev__card', '[data-nh-rev-prev]', '[data-nh-rev-next]');
    });
    e.target.querySelectorAll('[data-nh-pdp]').forEach(initPdp);
    initFooterQuote();
  });
})();
